import React from 'react';

import { Button, Typography } from 'antd';

import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';

import { SalePageLink } from './SalePageLink';

interface IProps {
  physicalProductPending: boolean;
  currentProduct: IProduct;
  currentUserId: number;
}

const SalesPageUrls = ({ physicalProductPending, currentProduct, currentUserId }: IProps) => {
  return (
    <div className='mt-5 max-w-full rounded-sm bg-white shadow-sm'>
      <div className='p-6 max-sm:px-2 max-sm:py-6'>
        <Typography.Title level={4} className='text-xl'>
          Crie sua página com Orbit Pages!
        </Typography.Title>
        <Typography.Text className='block text-sm'>
          Clientes Eduzz tem 3 páginas grátis! Clique no botão abaixo para começar.
        </Typography.Text>

        <Button
          type='primary'
          className='mt-2'
          href={constants.links.OrbitPage}
          target='_blank'
          rel='Reverse Tabnabbing noreferrer'
        >
          Criar minhas páginas - É grátis!
        </Button>

        <div className='pt-6'>
          <Typography.Title level={5}>Página de vendas / Padrão Eduzz</Typography.Title>
          <div className='w-[18.06rem] max-sm:w-full'>
            <SalePageLink
              currentProduct={currentProduct}
              currentUserId={currentUserId}
              physicalProductPending={physicalProductPending}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesPageUrls;
